import { render, staticRenderFns } from "./FormularioNotas.vue?vue&type=template&id=380bf53b&"
import script from "./FormularioNotas.vue?vue&type=script&lang=js&"
export * from "./FormularioNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports